var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          _vm.mode === "edit"
            ? _vm.$t("COMMON_EDIT")
            : _vm.$t("COMMON_ADD_ITEM"),
        visible: "",
        width: "45%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("MASTER_DATA_TABLE_HEADER_ITEM_SUBJECT"),
                prop: "itemSubject",
              },
            },
            [
              _c("el-input", {
                attrs: { maxlength: "100", disabled: _vm.mode === "edit" },
                model: {
                  value: _vm.ruleForm.itemSubject,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "itemSubject", $$v)
                  },
                  expression: "ruleForm.itemSubject",
                },
              }),
            ],
            1
          ),
          _c(
            "transition-group",
            { attrs: { name: "list-complete", tag: "div" } },
            _vm._l(_vm.ruleForm.valueList, function (item, index) {
              return _c(
                "el-row",
                { key: item.uid, staticClass: "list-complete-item" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "valueList." + index + ".itemValue",
                            rules: _vm.rules.valueName,
                            label: _vm.$t("MASTER_DATA_ADD_KEY"),
                            "label-width": "90px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100", clearable: "" },
                            model: {
                              value: item.itemValue,
                              callback: function ($$v) {
                                _vm.$set(item, "itemValue", $$v)
                              },
                              expression: "item.itemValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "valueList." + index + ".itemName",
                            rules: _vm.rules.keyName,
                            label: _vm.$t("MASTER_DATA_ADD_VALUE"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100", clearable: "" },
                            model: {
                              value: item.itemName,
                              callback: function ($$v) {
                                _vm.$set(item, "itemName", $$v)
                              },
                              expression: "item.itemName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "wl-icon-row", attrs: { span: 4 } },
                    [
                      _c("i", {
                        staticClass: "el-icon-arrow-down",
                        on: {
                          click: function ($event) {
                            return _vm.down(item)
                          },
                        },
                      }),
                      _c("i", {
                        staticClass: "el-icon-arrow-up",
                        on: {
                          click: function ($event) {
                            return _vm.up(item)
                          },
                        },
                      }),
                      _c("i", {
                        staticClass: "el-icon-delete",
                        on: {
                          click: function ($event) {
                            return _vm.deleteItem(item)
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "wl-add-container" },
            [
              _c(
                "el-button",
                { staticClass: "wl-green", on: { click: _vm.addItem } },
                [_vm._v(_vm._s(_vm.$t("COMMON_ADD")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: {
                type: "primary",
                loading: _vm.saveLoading,
                disabled: _vm.ruleForm.valueList.length === 0,
              },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }